import { client } from '@@api/client';
import { CONTENT_LANGUAGE_HEADER } from '@@api/constants/headers';
import { type RequestQuery } from '@@api/lib/types';
import { defaultQueryPlaceholderData } from '@@api/utils/defaultPlaceholderData';
import { type ContentLanguage } from '@@lib/i18n/constants';

import { USER_SOURCES } from './constants';

type UserQuery = RequestQuery<typeof client.auth.users.getAll>;

const userListQuery = (query: UserQuery, contentLocale: ContentLanguage) =>
    client.auth.users.getAll.queryOptions(
        { query, headers: { [CONTENT_LANGUAGE_HEADER]: contentLocale } },
        { placeholderData: defaultQueryPlaceholderData(query.size ?? 10) },
    );

/** The users lists' query per tab: all users, internal users and external users */
export const userTabQueries = (query: UserQuery, contentLocale: ContentLanguage) => ({
    all: userListQuery(query, contentLocale),
    internal: userListQuery({ ...query, userSource: USER_SOURCES.TAMEDIA }, contentLocale),
    external: userListQuery({ ...query, userSource: USER_SOURCES.EXTERNAL }, contentLocale),
});

export type UserTabQueries = ReturnType<typeof userTabQueries>;
